import styled from 'styled-components'
import { colors } from 'utils'

const Container = styled.div`
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    padding: 4px 8px;
    transform: translateY(-100%);
    background: #FFFFFF;
    box-shadow: 0px 2px 4px ${colors.shadow};
    border-radius: 2px;
    display: none;
    white-space: nowrap;
`

const Wrapper = styled.div`
    position: relative;
`

const Trigger = styled.div`
    &:hover ${Container} {
        display: block;
    }
`

const ContextMenu = { Container, Wrapper, Trigger }

export default ContextMenu
